module.exports = __webpack_public_path__ + "img/vibeify.12e4ea58.png";